import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-8]",
  templateUrl: "./wall-type-8.component.html",
  styleUrls: ["./wall-type-8.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType8Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Marketplace
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M1 122 L108 186 L108 ${baseHeight + 80} L0 ${baseHeight + 15} Z`,
        right: `M108 186 L310 66 L310 ${baseHeight - 40} L108 ${baseHeight + 80} Z`
    };

    return wallData[wallSide];
  }
}
